<template>
  <div class="calender-content">
    <el-calendar class="calender" v-model="today">
      <template #dateCell="{date}">
        <div class="cell">
          <p class="name">{{$moment(date).format('DD')}}</p>
          <!-- <p class="name">{{$moment(date).format('YYYY/MM/DD')}}</p> -->
          <div class="count-content" v-for="item in monthData" :key="item.date" >
            <p class="count" v-if="item.date === $moment(date).format('YYYY/MM/DD')">
              <span v-for="list in item.dataList" :key="(item.date + list.type)" @click="handleShowDetail(item.date, list)">
                <el-popover
                  placement="top-start"
                  width="800"
                  trigger="hover">
                  <span slot="reference" :class="['type-count', `type${list.type}`]" v-if="list.planVoList.length !== 0" >
                    {{ list.planVoList.length }}
                  </span>
                  <el-table :data="list.planVoList" style="width: 100%" height="400px"
                    header-cell-class-name='table-header-cell' cell-class-name='table-cell'
                    border stripe fit  highlight-current-row
                    >
                    <el-table-column prop="name" label="计划名称" min-width="280" show-overflow-tooltip></el-table-column>
                    <!-- <el-table-column prop="regionName" label="区域" min-width="100" :formatter="handleRegionName"></el-table-column> -->
                    <!-- <el-table-column prop="clientCompanyName" label="客户" min-width="200" show-overflow-tooltip></el-table-column> -->
                    <el-table-column prop="type" label="类型" min-width="100" :formatter="handleTypeFormat" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="status" label="状态" min-width="100" :formatter="handleStatusFormat" show-overflow-tooltip></el-table-column>
                    <!-- <el-table-column prop="creatorNickname" label="创建人" min-width="120" show-overflow-tooltip></el-table-column> -->
                    <el-table-column prop="time" label="计划起止时间" min-width="150" show-overflow-tooltip>
                      <template slot-scope="scope">
                        {{$moment(scope.row.startTime).format('YYYY/MM/DD')}}~{{$moment(scope.row.endTime).format('YYYY/MM/DD')}}
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="projectProcess" label="计划进度" min-width="100" show-overflow-tooltip></el-table-column> -->
                    <!-- <el-table-column prop="describe" label="描述" min-width="200" show-overflow-tooltip></el-table-column> -->
                  </el-table>
                </el-popover>
              </span>
            </p>
          </div>
        </div>
      </template>
    </el-calendar>
  </div>
</template>

<script>
export default {
  props: {
    monthData: Array
  },
  data() {
    return {
      today: new Date(),
      typeList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 },
        { label: "带电检测", value: 6 },
        { label: "电能安装", value: 7 }
      ],
      statusList: [
        { label: '漏检', value: 0 },
        { label: '待完成', value: 1 },
        { label: '已完成', value: 2 }
      ],
    }
  },
  methods: {
    handleTypeFormat (row, column, cellValue, index) {
      let val = ''
      this.typeList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    handleStatusFormat (row, column, cellValue, index) {
      let val = ''
      this.statusList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    handleShowDetail (date, list) {
      console.log(date, list)
    }
  },
  watch: {
    today (newV, oldV) {
      const month = this.$moment(newV).startOf('month').format('YYYY/MM/DD')
      this.$emit('handleChange', month)
    }
  }
}
</script>

<style lang="scss" scoped>
.calender-content {
  width: 100%;
  height: 100%;
  .calender {
    width: 100%;
    height: 100%;
  }
}

.count-content {
  box-sizing: border-box;
}

.count {
  margin-top: 8px;
}

.type-count {
  margin-top: 12px;
  padding: 3px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  box-sizing: border-box;
}

.type0 {
  margin-right: 8px;
  color: #333;
  border-bottom: 1px solid #F56C6C;
  border-right: 6px solid #F56C6C;
}

.type1 {
  margin-right: 8px;
  color: #333;
  border-bottom: 1px solid #409EFF;
  border-right: 6px solid #409EFF;
}

.type2 {
  color: #333;
  border-bottom: 1px solid #67C23A;
  border-right: 6px solid #67C23A;
}
</style>
